/* Info Component in IndexShotssPage */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";

const Info2 = () => {
  return (
    <div>
        <Row className='mb-3'>
            <Col className={`text-center px-3 py-1 ${styles.SubTitle6 }`} md={{span: 8, offset: 2 }}>
            <h5 className={`text-center pt-1 ${styles.Red }`} >INFO</h5> 
            <hr className={`mt-2 mb-0`}/>
            <p className='mt-2'><span className={`${styles.Red}`}>*</span> Click the <span className={`${styles.Red}`}>Add Indexshot</span> button
            to add Shots to the Series.</p>
            <p className='mt-2'><span className={`${styles.Red}`}>*</span> Click the <span className={`${styles.Red}`}>Shot Display</span> button 
            to display Shots with or without Background and Text. </p>
              <p className={`mt-2 ${styles.Small }`}>Note: A second Add Shot
              button will display at the bottom once Shots have been added.</p>
              <hr className={`mt-2 mb-0`}/>
            </Col>
        </Row>
    </div>
  )
}

export default Info2